//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { ConnectPanelActions } from '@catalog-ingestion/actions/connectPanelActions';
import { GoogleCatalogIngestionModalActions } from '@catalog-ingestion/actions/googleCatalogIngestionModalActions';
import { THRESHOLD_FAILED_CONFIRMATION_MODAL_ACTIONS } from '@catalog-ingestion/constants/thresholdFailedConfirmationModalConstants';
import { ICuralateStore } from '@models/AppState';
import { createAction } from '@utils/actions';
import { ReduxDispatch } from 'app/curalate.store';

const openThresholdFailedConfirmationModal = () => {
  return createAction({
    type: THRESHOLD_FAILED_CONFIRMATION_MODAL_ACTIONS.OPEN_MODAL,
  });
};

const closeThresholdFailedConfirmationModal = () => {
  return createAction({
    type: THRESHOLD_FAILED_CONFIRMATION_MODAL_ACTIONS.CLOSE_MODAL,
  });
};

export type ThresholdFailedConfirmationModalAction = ReturnType<
  typeof openThresholdFailedConfirmationModal |
  typeof closeThresholdFailedConfirmationModal
>;

export const ThresholdFailedConfirmationModalActions = {
  openThresholdFailedConfirmationModal,
  closeThresholdFailedConfirmationModal,

  continueWorkflow: () => (
    dispatch: ReduxDispatch,
  ) => {
    dispatch(GoogleCatalogIngestionModalActions.getNextPanel());
    dispatch(closeThresholdFailedConfirmationModal());
  },

  retryCatalogConnection: () => (
    dispatch: ReduxDispatch,
    getState: () => ICuralateStore,
  ) => {
    dispatch(closeThresholdFailedConfirmationModal());
    if (getState().catalogIngestionReducers.connectPanel.isValidating) {
      dispatch(ConnectPanelActions.toggleIsValidating());
    }
    dispatch(GoogleCatalogIngestionModalActions.resetGoogleCatalogIngestionState());
    dispatch(GoogleCatalogIngestionModalActions.openGoogleCatalogIngestionModal());
  },
};
